<header *ngIf="!isScreenSaverPage" [ngClass]="{'vu-mode': isVUMode}">
  <app-page-header></app-page-header>
</header>
<main role="main" [ngClass]="{index: isRootPage, 'h-75': isPageH75, 'vu-mode': isVUMode, 'screen-saver': isScreenSaverPage}">
  <!-- <app-title></app-title> -->
  <ngx-spinner [bdColor]="'rgba(0, 0, 0, 0.3)'" size="large" type="ball-spin-clockwise-fade"></ngx-spinner>
  <app-notification-massage></app-notification-massage>
  <span [ngClass]="{'vu-zoom': isVUMode}">
    <router-outlet></router-outlet>
  </span>
</main>

<footer *ngIf="!isScreenSaverPage">
  <app-page-footer *ngIf="!isVUMode && !isKiosk"></app-page-footer>
</footer>
<app-cookie-message *ngIf="!isKiosk"></app-cookie-message>
